import { IconButton, Input, InputGroup, InputLeftElement, InputRightElement, useColorModeValue } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
export function SearchBar(props: {
	variant?: string;
	background?: string;
	children?: JSX.Element;
	placeholder?: string;
	borderRadius?: string | number;
	[x: string]: any;
}) {
	// Pass the computed styles into the `__css` prop
	const { variant, background, children, placeholder, borderRadius, ...rest } = props;
	// Chakra Color Mode
	const searchIconColor = useColorModeValue('primary.100', 'white');
	const inputBg = useColorModeValue('blue.300', 'darkGray.300');
	const inputText = useColorModeValue('black', 'white');
	return (
		<InputGroup w={{ base: '100%', md: '400px' }} {...rest}>
			<InputRightElement
				children={
					<IconButton
						aria-label='search'
						bg='inherit'
						borderRadius='inherit'
						_active={{
							bg: 'inherit',
							transform: 'none',
							borderColor: 'transparent'
						}}
						_focus={{
							boxShadow: 'none'
						}}
						icon={<SearchIcon color={searchIconColor} w='15px' h='15px' />}
					/>
				}
			/>
			<Input
				variant='search'
				fontSize='sm'
				bg={background ? background : inputBg}
				color={inputText}
				fontWeight='500'
				_placeholder={{ color: 'primary.300', fontSize: '16px' }}
				borderRadius={borderRadius ? borderRadius : '5px'}
				placeholder={placeholder ? placeholder : 'Search...'}
			/>
		</InputGroup>
	);
}
